class CartaCorrecao {
  constructor() {
    this.idNotaFiscal = null

    this.notaAnterior = {
      idTomadorDados: null,
      discriminacaoServico: '',
      valorInss: 0,
      valorIr: 0,
      valorCsll: 0,
      valorPis: 0,
      valorCofins: 0
    }

    this.notaNovo = {
      idTomadorDados: null,
      discriminacaoServico: '',
      valorInss: 0,
      valorIr: 0,
      valorCsll: 0,
      valorPis: 0,
      valorCofins: 0
    }
  }
}

export default CartaCorrecao
